// frontend/admin-portal/src/components/suppliers/SupplierFilters.jsx
import React from "react";
import { Input } from "@fiberhome/shared-ui";

export default function SupplierFilters({ filters, onChange }) {
  const set = (key, value) => onChange({ ...filters, [key]: value, page: 1 });

  return (
    <div className="fh-supplier-filters">
      <Input
        placeholder="Search by name, code, contact, email, phone..."
        value={filters.search || ""}
        onChange={(e) => set("search", e.target.value)}
      />
      <input
        className="fh-input"
        placeholder="Country"
        value={filters.country || ""}
        onChange={(e) => set("country", e.target.value)}
      />
      <input
        className="fh-input"
        placeholder="City"
        value={filters.city || ""}
        onChange={(e) => set("city", e.target.value)}
      />
      <select
        className="fh-input"
        value={filters.isActive || ""}
        onChange={(e) => set("isActive", e.target.value)}
      >
        <option value="">All statuses</option>
        <option value="true">Active only</option>
        <option value="false">Inactive only</option>
      </select>
    </div>
  );
}
